var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTraffic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7888 9.66699L14.3301 11.3337L12.7888 13.0003",
    stroke: "#ADAAE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7888 3L14.3301 4.66667L12.7888 6.33333",
    stroke: "#ADAAE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.3333H4.7354C5.15825 11.3333 5.57457 11.2204 5.94739 11.0047C6.32022 10.7889 6.63802 10.477 6.8726 10.0965L8.165 8",
    stroke: "#ADAAE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.6665H4.7354C5.15825 4.66651 5.57457 4.7794 5.94739 4.99516C6.32022 5.21091 6.63802 5.52286 6.8726 5.90331L9.4574 10.0964C9.69198 10.4768 10.0098 10.7888 10.3826 11.0045C10.7554 11.2203 11.1717 11.3332 11.5946 11.3332H13.3025",
    stroke: "#ADAAE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3025 4.66699H11.5946C11.1718 4.667 10.7555 4.77989 10.3826 4.99565C10.0098 5.2114 9.69202 5.52335 9.45744 5.9038L9.19254 6.33366",
    stroke: "#ADAAE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraffic);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjc4ODggOS42NjY5OUwxNC4zMzAxIDExLjMzMzdMMTIuNzg4OCAxMy4wMDAzIiBzdHJva2U9IiNBREFBRTMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEyLjc4ODggM0wxNC4zMzAxIDQuNjY2NjdMMTIuNzg4OCA2LjMzMzMzIiBzdHJva2U9IiNBREFBRTMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIgMTEuMzMzM0g0LjczNTRDNS4xNTgyNSAxMS4zMzMzIDUuNTc0NTcgMTEuMjIwNCA1Ljk0NzM5IDExLjAwNDdDNi4zMjAyMiAxMC43ODg5IDYuNjM4MDIgMTAuNDc3IDYuODcyNiAxMC4wOTY1TDguMTY1IDgiIHN0cm9rZT0iI0FEQUFFMyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMiA0LjY2NjVINC43MzU0QzUuMTU4MjUgNC42NjY1MSA1LjU3NDU3IDQuNzc5NCA1Ljk0NzM5IDQuOTk1MTZDNi4zMjAyMiA1LjIxMDkxIDYuNjM4MDIgNS41MjI4NiA2Ljg3MjYgNS45MDMzMUw5LjQ1NzQgMTAuMDk2NEM5LjY5MTk4IDEwLjQ3NjggMTAuMDA5OCAxMC43ODg4IDEwLjM4MjYgMTEuMDA0NUMxMC43NTU0IDExLjIyMDMgMTEuMTcxNyAxMS4zMzMyIDExLjU5NDYgMTEuMzMzMkgxMy4zMDI1IiBzdHJva2U9IiNBREFBRTMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEzLjMwMjUgNC42NjY5OUgxMS41OTQ2QzExLjE3MTggNC42NjcgMTAuNzU1NSA0Ljc3OTg5IDEwLjM4MjYgNC45OTU2NUMxMC4wMDk4IDUuMjExNCA5LjY5MjAyIDUuNTIzMzUgOS40NTc0NCA1LjkwMzhMOS4xOTI1NCA2LjMzMzY2IiBzdHJva2U9IiNBREFBRTMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };